/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProcessInstrumentUnlinkEventsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/ProcessInstrumentUnlinkEvents.pb'
import {ProcessInstrumentUnlinkEventsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/ProcessInstrumentUnlinkEvents.pb'


export const processInstrumentUnlinkEvents = (request:ProcessInstrumentUnlinkEventsRequest, options?: CashRequestOptions) => post<ProcessInstrumentUnlinkEventsRequest, ProcessInstrumentUnlinkEventsResponse>("/2.0/cash/process-instrument-unlink-events", request, {...options, rejectOnError: true })